import { useMemo } from 'react';
import { useCreateBlockNote } from '@blocknote/react';
import { BlockNoteView } from '@blocknote/mantine';
import '@blocknote/mantine/style.css';

export function BlockNoteReadOnly({ content }: { content: unknown[] }) {
  if (!content || content.length === 0) {
    return null;
  }

  const contentKey = useMemo(() => JSON.stringify(content), [content]);
  const editor = useCreateBlockNote({
    initialContent: content as any,
  }, [contentKey]);

  return (
    <div className="text-sm [&_.bn-editor]:!text-sm pointer-events-none">
      <BlockNoteView editor={editor} editable={false} theme="light" />
    </div>
  );
}
